import addToCart from '../utils/_addToCart';
import { scrollIntoViewWithOffset } from '../forms/check/_index';

var dyHelpers = require('../utils/_dyHelpers');

class mPdpActions extends HTMLDivElement {
    constructor() {
        super();
        this.variationGroupId = this.closest('[is="o-pdp-grid"]').dataset.variationGroupId;
        this.colorSelectors = this.querySelectorAll('.btn-filter-color');
        this.sizeSelectors = this.querySelectorAll('.size-btn');
        this.sizeSection = this.querySelector('[is="m-pdp-sizes-filter"]');
        this.productSku = document.querySelector('#productSku');

        // containers (keep in mind that mobile has 2x size/prices/add2Cart containers)
        this.pricesContainers = document.querySelectorAll('[is="m-pdp-infos-header"] .prices, [is="m-pdp-bar-minicard"] .prices');
        this.addToCartContainers = document.querySelectorAll('.add-to-cart-actions');
        this.sizesContainers = document.querySelectorAll('[is="m-pdp-sizes-filter"]');
        this.avaiabilityContainer = this.querySelector('.product-stock-info');
        this.colorContainer = this.querySelector('[is="m-pdp-colors-filter"] .info');
        this.pdpBarImage = document.querySelector('[is="m-pdp-bar-minicard"] img');

        // bind this
        this.updateSizes = this.updateSizes.bind(this);
        this.onColorSelection = this.onColorSelection.bind(this);
        this.onSizeSelection = this.onSizeSelection.bind(this);
        this.onAddToCart = this.onAddToCart.bind(this);
        this.triggerUpdateAction = this.triggerUpdateAction.bind(this);
        this.updateActions = this.updateActions.bind(this);    
    }

    connectedCallback() {
        if (this.colorSelectors.length > 1) {
            for (let colorSelector of this.colorSelectors) {
                colorSelector.addEventListener('click', this.onColorSelection);
            }
        }
        document.addEventListener('click', this.onSizeSelection);
        document.addEventListener('click', this.onAddToCart);

        // Trigger unique size/product variation add to cart buttons
        const sizeSelectedOnLoading = document.querySelector('.size-btn[data-selected="true"]');
        if (sizeSelectedOnLoading && !sizeSelectedOnLoading.disabled) {
            sizeSelectedOnLoading.click();
        }
    }

    onAddToCart(e) {
        const currentBtn = e.target.closest('.add-to-cart');

        if (currentBtn) {
            const isRecommendation = currentBtn.closest('.recommendation-item') !== null;
            const isInQuickbuySidebar = currentBtn.closest('[is="m-quickview"]') !== null;
            const isDisabled = currentBtn.disabled;

            if (isDisabled || isRecommendation || isInQuickbuySidebar) {
                return;
            }

            if (currentBtn.classList.contains('add-to-cart-no-size-selected')) {
                var errorElement = this.querySelector('.select-size-error');

                if (errorElement) errorElement.removeAttribute('hidden');

                    const mPdpSizeFilterEl = errorElement.closest('[is="m-pdp-form-addtocart"]').previousElementSibling;
                    const sizeTitleEl = mPdpSizeFilterEl.querySelector('.header'); // offset to make sure size are selectable on scroll up
                    const firstSizeButtonEl = mPdpSizeFilterEl.querySelector('.size-btn');

                    if (sizeTitleEl) scrollIntoViewWithOffset(sizeTitleEl, window, true);
                    if (firstSizeButtonEl) { // focus after scrolling transition for a11y
                        setTimeout(() => { firstSizeButtonEl.focus(); }, 800);
                    }
                return;
            }

            addToCart(currentBtn, 'Product Page', () => {
                // Refetch Availability Message
                fetch(this.currentVariationStockUrl, { method: 'GET' }).then((avaiabilityResponse) => {
                    return avaiabilityResponse.json();
                }).then((avaiabilityResponseText) => {
                    this.updateAvailability(avaiabilityResponseText.stockInfoText);
                });
            });
        }
    }

    onSizeSelection(e) {
        const currentBtn = e.target.closest('.size-btn');
        const currentBtnIsNotInQuickbuySidebar = !e.target.closest('[is="m-quickview"]');

        if (currentBtn && currentBtnIsNotInQuickbuySidebar) {
            const newProductId = currentBtn.dataset.pid;
            const sizeBtnContainers = document.querySelectorAll('[is="a-btn-size"]');
            let sizeBtns = [];

            for (let btnContainers of sizeBtnContainers) {
                let currentContainerBtns = btnContainers.querySelectorAll('.size-btn');
                for (const currentContainerBtn of currentContainerBtns) {
                    sizeBtns.push(currentContainerBtn);
                }
            }

            const displayActionUrl = currentBtn.dataset.displayActionUrl;

            if (typeof currentBtn.dataset.target === 'undefined') {
                let variationStockUrl = new URL(currentBtn.dataset.stockUrl);
                variationStockUrl.searchParams.set('pid', newProductId);
                this.currentVariationStockUrl = variationStockUrl.toString();

                // Fill Availability Message
                fetch(this.currentVariationStockUrl, { method: 'GET' }).then((avaiabilityResponse) => {
                    return avaiabilityResponse.json();
                }).then((avaiabilityResponseText) => {
                    this.updateAvailability(avaiabilityResponseText.stockInfoText);
                    this.updatePrice(avaiabilityResponseText.price.formatted);
                    if (avaiabilityResponseText.gtmData) {
                        document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                            detail: {
                                data: avaiabilityResponseText.gtmData
                            }
                        }));
                    }
                    dyHelpers.setDyRecommendationContext({ data: [newProductId] }); // Update SKU for DY recommendations
                    this.updateFindInStorePanelData(newProductId);
                    this.updateSku(newProductId);
                });

                // Load Add to cart Buttons
                this.triggerUpdateAction(displayActionUrl);

                // Unselect all buttons then select current Button
                this.selectSizeButton(sizeBtns, currentBtn.dataset.pid);
            } else {
                this.selectSizeButton(sizeBtns, ''); // Unselect all buttons
            }
        }
    }

    selectSizeButton(arrayOfButtons, selectedPid) {
        if (arrayOfButtons && selectedPid) {
            for (let button of arrayOfButtons) {
                if (button.dataset.pid === selectedPid) {
                    button.dataset.selected = true;
                } else {
                    button.dataset.selected = false;
                }
            }
        }
    }

    onColorSelection(e) {
        let productVariationUrl = e.currentTarget.dataset.url;
        let currentBtn = e.currentTarget;
        let allColorBtns = e.currentTarget.closest('[is="m-btn-color"]').querySelectorAll('.btn-filter-color');
        this.kleepButton = document.querySelector('[is="m-pdp-actions"] [is="m-pdp-sizes-filter"] .kleep-button')?.innerHTML;

        fetch(productVariationUrl, {
            method: 'GET'
        }).then((response) => {
            return response.json();
        }).then((responseData) => {
            dyHelpers.setDyRecommendationContext({ data: [responseData.productVariantId] }); // Update SKU for DY recommendations
            let displayActionUrl = responseData.updateActionUrl;
            this.variationAvaiabilityUrl = responseData.updateStockUrl;
            this.updatePrice(responseData.product.price.html);
            this.updateColor(responseData.product.variationAttributesMapping.color.displayValue);
            this.updateSizes(responseData.productSizesHtml);
            this.updateSku(responseData.product.id);

            // Reload product images with new content
            document.dispatchEvent(new CustomEvent('mPdpImages:reload', {
                detail: {
                    productImagesHtml: responseData.productImagesHtml
                }
            }));

            this.triggerUpdateAction(displayActionUrl);

            for (let colorBtn of allColorBtns) {
                colorBtn.classList.remove('active');
            }

            // Reset stock info message on click on color change
            if(this.querySelector('.product-stock-info')) {
                this.querySelector('.product-stock-info').innerText = '';
            }

            currentBtn.classList.add('active');
            if (responseData.gtmData) {
                document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                    detail: {
                        data: responseData.gtmData
                    }
                }));
            }
            this.updateFindInStorePanelData(responseData.product.id);
            this.updatePdpBarImage(responseData);
            this.showSizes(!responseData.product.isFindInStore);

            // replace init html kleep by old one
            var getKleep = document.querySelector('[is="m-pdp-actions"] [is="m-pdp-sizes-filter"] .kleep-button');
            if (getKleep) getKleep.innerHTML = this.kleepButton;
        });
    }

    updatePrice(html) {
        if (this.pricesContainers && html) {
            for (let container of this.pricesContainers) {
                container.innerHTML = html;
            }
        }
    }

    triggerUpdateAction(url) {
        fetch(url, { method: 'GET' }).then((displayActionResponse) => {
            return displayActionResponse.text();
        }).then((actionResponseHtml) => {
            this.updateActions(actionResponseHtml);
        });
    }

    updateActions(html) {
        if (html) {
            for (let container of this.addToCartContainers) {
                container.innerHTML = html;
            }
            document.dispatchEvent(new CustomEvent('mPdpBar:updateIntersectionObserver'));
        }
    }

    updateSizes(html) {
        if (html && this.sizesContainers) {
            for (let container of this.sizesContainers) {
                container.outerHTML = html;
            }
        }

        // update containerVar with new element
        this.sizesContainers = document.querySelectorAll('[is="m-pdp-sizes-filter"]');
        this.avaiabilityContainer = this.querySelector('.product-stock-info');
    }

    updateAvailability(string) {
        if (this.avaiabilityContainer) {
            this.avaiabilityContainer.innerText = string;
        }
    }

    updateColor(string) {
        this.colorContainer.innerText = string;
    }

    updateFindInStorePanelData(productId) {
        if (productId) document.querySelector('.product-detail').setAttribute('data-pid', productId);
    }

    updatePdpBarImage(data) {
        if (data && data.product && data.product.productImages && data.product.productImages[0]) {
            const currentImage = data.product.productImages[0];

            if (currentImage.url) this.pdpBarImage.src = currentImage.url + '?twic=v1/cover=4:5/resize=21';
            if (currentImage.alt) this.pdpBarImage.alt = currentImage.alt;
        }
    }

    updateSku(productSkuR) {
        if (this.productSku) {
            this.productSku.textContent = productSkuR;
        }
    }

    showSizes(toggle) {
        if (this.sizeSection) {
            this.sizeSection.classList.toggle('d-none', toggle);
            this.sizeSection.setAttribute('aria-hidden', toggle);
        }
    }
}

customElements.define('m-pdp-actions', mPdpActions, {
    extends: 'div'
});
